var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.923 4.51v-.593a2.917 2.917 0 1 0-5.833 0v.593a2.08 2.08 0 0 0-1.25 1.907v2.5A2.086 2.086 0 0 0 3.923 11H8.09a2.086 2.086 0 0 0 2.083-2.083v-2.5a2.08 2.08 0 0 0-1.25-1.907m-2.5 3.573a.417.417 0 1 1-.833 0V7.25a.417.417 0 1 1 .833 0zm1.667-3.75H3.923v-.416a2.083 2.083 0 0 1 4.167 0z"
})));
export { SvgLockIcon as ReactComponent };
export default __webpack_public_path__ + "8d1621ffd26de3d501f0866a51033207.svg";